import { render, staticRenderFns } from "./ExternalLinkManagementForm.vue?vue&type=template&id=6c846c7f&scoped=true"
import script from "./ExternalLinkManagementForm.vue?vue&type=script&lang=js"
export * from "./ExternalLinkManagementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c846c7f",
  null
  
)

export default component.exports